export class NotFoundException extends Error {
  public readonly statusCode: number = 404;
}
